module.exports = __webpack_public_path__ + "img/recycler.ca7aab07.svg";